import {
  Form,
  GuaranteeFilter as Filter,
  guaranteeDefaultFilter,
  columns,
  initialValues,
  Details,
} from 'modules/guarantee';
import {
  CreateScene,
  DeleteScene,
  DetailsScene,
  EntityNav,
  EntityScene,
  ModelScene,
  IndexScene,
  UpdateScene,
} from 'components';
import { Guarantee } from 'modules/guarantee/types';
import { ListExport } from 'components/ListActions';
import { copyGuarantee } from 'modules/guarantee/util';

const model = {
  endpoint: 'guarantee/global/agency/',
  title: 'Agency guarantee',
  pluralTitle: 'Agency guarantees',
  entityTitle: (g: Guarantee) => g.number,
  permissions: undefined,
};

export const route = {
  path: 'agency',
  element: <ModelScene {...model} />,
  children: [
    {
      index: true,
      element: (
        <IndexScene
          defaultFilter={guaranteeDefaultFilter}
          columns={columns}
          toolbar={<ListExport />}
          filterFields={<Filter />}
        />
      ),
    },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialValues}>
          <Form global={true} />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: (
        <EntityScene>
          <EntityNav
            nav={[
              {
                to: '',
                end: true,
                children: 'Details',
              },
              {
                to: 'update',
                children: 'Update',
              },
            ]}
          />
        </EntityScene>
      ),
      children: [
        {
          index: true,
          element: (
            <DetailsScene heading={null}>
              <Details global={true} />
            </DetailsScene>
          ),
        },
        {
          path: 'update',
          element: (
            <UpdateScene heading={null} createPath="../../create" deletePath="../delete" copy={copyGuarantee}>
              <Form global={true} />
            </UpdateScene>
          ),
        },
        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ],
};
